import { connect } from 'react-redux';
import GTEstimateDashboard from 'components/gtestimate/GTEstimateDashboard';
import {
  fetchGTEstimateData,
  clearGTEstimateData,
  rerunGTEstimateData,
  updateEstimations,
  deleteEstimations,
  resetProcessing,
} from 'data/gtestimate/GTEstimate.actions';

import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      dashboardData: state.gtestimate.dashboardData,
      insurances: state.gtestimate.dashboardData?.Insurances,
      rerunData: state.gtestimate.rerunData,
      deleteData: state.gtestimate.deleteData,
      updateData: state.gtestimate.updateData,
      resetProcessing: state.gtestimate.resetProcessing,
      hasError:
        state.gtestimate.dashboardDataError != null ||
        state.gtestimate.rerunError != null ||
        state.gtestimate.deleteError != null ||
        state.gtestimate.resetProcessingError != null ||
        state.gtestimate.updateError != null,
      loading:
        state.gtestimate.fetchingDashboardData ||
        state.gtestimate.rerunningData ||
        state.gtestimate.deletingData ||
        state.gtestimate.resetingProcessing ||
        state.gtestimate.updatingData,
      user: state.app.user,
      userParty: state.app.userParty,
    },
    state,
    'gtEstimationStatuses',
    'partyTypes'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchData: insuranceID => {
      dispatch(fetchGTEstimateData(insuranceID));
    },
    clearData: () => {
      dispatch(clearGTEstimateData());
    },
    runPendingEstimations: insuranceID => {
      dispatch(
        rerunGTEstimateData(null, false, null, true, insuranceID, null, null)
      );
    },
    resetProcessingEstimations: insuranceID => {
      dispatch(resetProcessing(insuranceID));
    },
    runFailedEstimations: insuranceID => {
      dispatch(
        rerunGTEstimateData(null, false, true, null, insuranceID, null, null)
      );
    },
    deleteEstimations: estimationIDs => {
      dispatch(deleteEstimations(estimationIDs));
    },
    rerunSelectedEstimations: (estimations, forceRun) => {
      dispatch(
        rerunGTEstimateData(estimations, forceRun, null, null, null, null, null)
      );
    },
    rerunAllEstimations: (
      estimations,
      forceRun,
      allFailed,
      allPending,
      insuranceId,
      dateFrom,
      dateTo
    ) => {
      dispatch(
        rerunGTEstimateData(
          estimations,
          false,
          allFailed,
          allPending,
          insuranceId,
          dateFrom,
          dateTo
        )
      );
    },
    updateEstimations: (dateFrom, dateTo, insuranceId) => {
      dispatch(updateEstimations(dateFrom, dateTo, insuranceId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GTEstimateDashboard);
